import 'bootstrap/dist/css/bootstrap.min.css';
import React, { useEffect, useState } from 'react';
import { CloseButton, Col, Container, Image, Row, Spinner, Tab, Tabs, Table  } from 'react-bootstrap';
import * as Icon from 'react-bootstrap-icons';
import Category from './Category';
import Footer from './Footer';
import Header from './Header';
import { useTranslation } from "react-i18next";
import * as RIcon from "react-icons/fa"
import { Link, useLocation, useNavigate } from 'react-router-dom';
import CardRegist from './common/CardRegist';
import { Alert, Button, Card, CardContent, CardHeader, CardMedia, Chip, Typography } from '@mui/material';
import ApiFetch from './ApiFetch';
import CommonDialog from './common/CommonDialog';
import LoadingButton from '@mui/lab/LoadingButton';
import DirectdebitRegist from './common/DirectdebitRegist';
import Constants from './common/Constants';
import ChargeDirectdebitRegist from './common/ChargeDirectdebitRegist';

const Coin = () => {
	async function getCoinInfo(){
        return await new ApiFetch().get(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/coin/coinInfo").then((r)=>r.json().then((json)=>{
            return json
        }))
    }
	async function getPayoutsHistory(){
        return await new ApiFetch().get(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/payment/payouts").then((r)=>r.json().then((json)=>{
            return json
        }))
    }
	async function updatePaymentMethod(id,statusToken){
        return await new ApiFetch().put(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/payment/method",{id:id,statusToken:statusToken}).then((r)=>r.json().then((json)=>{
            return json
        }))
    }
	async function updateDefault(id,flag){
        return await new ApiFetch().put(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/payment/default",{id:id,flag:flag}).then((r)=>r.json().then((json)=>{
            return json
        }))
    }
	async function deleteCard(id){
        return await new ApiFetch().delete(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/payment/card",{id:id}).then((r)=>r.json().then((json)=>{
            return json
        }))
    }
	async function getBankInfo(){
        return await new ApiFetch().get(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/coin/chargeBank").then((r)=>r.json().then((json)=>{
            return json
        }))
    }
	async function getShienInfo(){
        return await new ApiFetch().get(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/payouts/shien").then((r)=>r.json().then((json)=>{
            return json
        }))
    }
	async function getUpdateInfo(){
        return await new ApiFetch().put(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/payouts/bank").then((r)=>r.json().then((json)=>{
            return json
        }))
    }
	async function getDeleteInfo(){
        return await new ApiFetch().delete(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/payouts/bank").then((r)=>r.json().then((json)=>{
            return json
        }))
    }
    const {t,i18n} = useTranslation()
    const navigate = useNavigate()
    const location = useLocation()
    const [selected,setSelected] = useState(0)
    const [showRegistConfirm,setShowRegistConfirm] = useState(false)
    const [showDeleteConfirm,setShowDeleteConfirm] = useState(false)
    const [showDefaultConfirm,setShowDefaultConfirm] = useState(false)
    const [loadingPaymentStatus,setLoadingPaymentStatus] = useState(false)
    const [loadingPaymentDefault,setLoadingPaymentDefault] = useState(false)
    const [loading,setLoading] = useState(true)
    const [coinInfo,setCoinInfo] = useState([])
    const [chargeList,setChargeList] = useState([])
    const [usageList,setUsageList] = useState([])
    const [coin,setCoin] = useState(-1)
    const [payoutsHistory,setPayoutsHistory] = useState([])
    const [bankInfo,setBankInfo] = useState([])
    const [shienInfo,setShienInfo] = useState([])
    let param = location.search
    useEffect(() => {
        let id = param.substring(param.indexOf("id?=")+5,param.indexOf("&statusToken="))
        let statusToken = param.substring(param.indexOf("&statusToken=")+13)
        if(id.length === 36 && statusToken.length > 0){
            setLoadingPaymentStatus(true)
            updatePaymentMethod(id,statusToken).then(r => {
                if(r.result){
                    if(r.data.status){
                        setTimeout(() => window.location.href = "/payment?status=OK",1000)
                    } else {
                        window.location.href = "/payment?status=NG"    
                    }
                } else {
                    alert(r.errors)
                }
                setLoadingPaymentStatus(false)
            })
        } else {
            getCoinInfo().then(r => {
                if(r.result){
                    setCoinInfo(r.data)
                    setCoin(r.data.coin)
                    setChargeList(r.data.chargeList)
                    setUsageList(r.data.usageList)
                }
                setLoading(false)
            })
            getPayoutsHistory().then(r => {
                if(r.result){
                    setPayoutsHistory(r.data)
                }
                setLoading(false)
            })
        }
        // 銀行口座
        getBankInfo().then(r => {
            if(r.result){
                setBankInfo(r.data)
            }
        })
        // 支援金額等
        getShienInfo().then(r => {
            if(r.result){
                setShienInfo(r.data)
            }
        })
    },[])

    return(
    <div className="wrapper" style={{backgroundColor:"#EEEEEE",borderRadius:"10px"}}>
        <header className="App-header"></header>
        <Header />
        <Category />
        <CommonDialog open={showRegistConfirm}
            content={<ChargeDirectdebitRegist bank={bankInfo}
                onRegist={() => {
                    getBankInfo().then(r => {
                        if(r.result){
                            setBankInfo(r.data)
                        }
                    })
                }}
            />}
            onClick={() => setShowRegistConfirm(false)} onClose={() => {
                setShowRegistConfirm(false)
                getBankInfo().then(r => {
                    if(r.result){
                        setBankInfo(r.data)
                    } else {
                        setBankInfo()
                    }
                })
            }}
            />
        <CommonDialog open={showDeleteConfirm}
            onClick={() => {
                setShowDeleteConfirm(false)
                deleteBank().then(r => {
                    if(r.result){
                        getBankInfo().then(r => {
                            if(r.result){
                                window.location.reload()
                                setBankInfo(r.data)
                            }
                        })
                    }
                })
            }} onClose={() => setShowDeleteConfirm(false)}
            title="振込先口座を削除しますか？" buttonLabel="削除" buttonColor="warning" showCancelbutton={true} />
        <CommonDialog open={showDefaultConfirm}
            onClick={() => {
                setShowDefaultConfirm(false)
            }} onClose={() => setShowDefaultConfirm(false)}
            title="標準に設定しました。" buttonLabel="OK" buttonColor="info" />
        <Container className='w-100'>
            {loadingPaymentStatus ? <Container className='text-center m-3'><Spinner animation="border" size="sm" /> 登録状況を確認しています。</Container> : ""}
            {param.indexOf("status=OK") !== -1 ? <Alert className='m-3'>支払方法が登録されました。<CloseButton onClick={() => navigate("/payment")} /></Alert> : ""}
            {param.indexOf("status=NG") !== -1 ? <Alert severity='error' className='m-3'>支払方法の登録に失敗しました。<CloseButton onClick={() => navigate("/payment")} /></Alert> : ""}
            <h4>コイン管理/履歴</h4>
            <Row className='mb-4 text-left p-3' style={{backgroundColor:"#FFFFFF"}}>
                <Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12}>
                    <div>残高</div>
                    {coin === -1 ? <Spinner size='sm' /> : (
                        <div style={{fontWeight:"bold",fontSize:"36px"}}>{Constants.CURRENCY_UNIT_LEFT_COIN} {(coin || 0).toLocaleString()}</div>
                    )}
                    <Button variant='contained' className='mt-2' onClick={() => setShowRegistConfirm(true)}>
                        銀行振り込みでコインを購入する
                    </Button>
                    <br />
                    <span style={{fontSize:"14px"}} className='mt-1'>1度に10000コイン以上購入すると、生成機能で利用できる10000ポイントをプレゼント！。</span>
                </Col>
            </Row>
            <Tabs defaultActiveKey={"charge"} onSelect={() => {}}>
                <Tab eventKey="charge" title="チャージ履歴">
                    <Row className='mb-4 text-center p-3' style={{backgroundColor:"#FFFFFF"}}>
                        <Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12}>
                            <Table striped bordered hover style={{width:"100%"}}>
                                <thead>
                                    <tr><th>チャージ日時</th><th>コイン</th><th>有効期限</th><th>状態</th></tr>
                                </thead>
                                <tbody>
                                    {chargeList.map(d => {
                                        let list = ["有効","無効","使用済"]
                                        return <tr><td>{d.create_datetime}</td><td>{Constants.CURRENCY_UNIT_LEFT_COIN} {(d.coin).toLocaleString()}</td><td>{d.expire_date}</td><td>{list[d.status]}</td></tr>
                                    })}
                                </tbody>
                            </Table>
                        </Col>
                    </Row>
                </Tab>
                <Tab eventKey="usage" title="使用履歴">
                    <Row className='mb-4 text-center p-3' style={{backgroundColor:"#FFFFFF"}}>
                        <Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12}>
                            <Table striped bordered hover style={{width:"100%"}}>
                                <thead>
                                    <tr><th>使用日時</th><th>名称</th><th>コイン</th></tr>
                                </thead>
                                <tbody>
                                    {usageList.map(d => {
                                        return <tr><td>{d.create_datetime}</td><td style={{cursor:d.buy_div === "PLAN" || d.buy_div === "IMAGE" || d.name === "応援コメント" ? "pointer" : "inherit"}} onClick={() => {
                                            if(d.buy_div === "PLAN"){
                                                navigate("/user/"+d.item_or_plan_user_id+"/plans")
                                            }
                                            if(d.buy_div === "IMAGE"){
                                                navigate("/image/"+d.id)
                                            }
                                            if(d.name === "応援コメント"){
                                                navigate("/"+d.post_type+"/"+d.post_group_id)
                                            }
                                        }}>{d.buy_div === "PLAN" || d.buy_div === "IMAGE" ? <Chip style={{fontSize:"12px"}} label={d.buy_div === "PLAN" ? "支援" : "購入"} /> : ""} {d.post_type === "generate_image" ? "画像生成" : d.name}</td><td>{Constants.CURRENCY_UNIT_LEFT_COIN} {d.coin.toLocaleString()}</td></tr>
                                    })}
                                </tbody>
                            </Table>
                        </Col>
                    </Row>
                </Tab>
            </Tabs>
        </Container>
        <Footer />
    </div>
    )
}

export default Coin;
